export default __webpack_public_path__ + "static/media/shade-b.89781eed.svg";